module.exports = __webpack_public_path__ + "img/icon_deal__scence@3x.12499ccc.png";